import React from 'react'
import type { RadioGroupProps as AntdRadioGroupProps } from 'antd/lib/radio'
import Radio from 'antd/lib/radio'
import { connectReadonlyComponent } from '../connect'
import PreviewText from '../preview-text'

export type RadioGroupProps = AntdRadioGroupProps & {
  readonly?: boolean
}

export default connectReadonlyComponent(Radio.Group, PreviewText.Select)
